$(document).ready( function () {

	/*
	 * Twitter share link
	 * Available data parameters:
	 *	data-twitter-text="The body of the tweet"
	 *	data-twitter-link="The URL to share on twitter"
	 *
	 * Example:
	 *	<a href="#" class="j-share-twitter" data-twitter-text="227 do some clever stuff!" data-twitter-link="http://www.twotwentyseven.com/">Share on Twitter</a>
	 **/

	$(document).on('click', '.j-share-twitter', function(e) {
		e.preventDefault();
		var tweet_text = $(this).data('twitter-text') || '';
		var tweet_link = encodeURIComponent( $(this).data('twitter-link') || '');
		var hashtags = $(this).data('twitter-hashtags') || '';

		// If none of the parameters have been specified then don't bother opening the popup
		if ('' == tweet_text && '' == tweet_url && '' == hashtags ) {
			return;
		}

		popUp=window.open('https://twitter.com/intent/tweet?text=' + tweet_text + '&url=' + tweet_link + '&hashtags=' + hashtags, 'popupwindow', 'scrollbars=yes,width=800,height=400');
		popUp.focus();
	});


	/*
	 * Facebook share link
	 * Available data parameters
	 *	data-facebook-name="The blue title in the feed item"
	 *	data-facebook-link="The URL to share"
	 *	data-facebook-picture="The image to show in the feed post"
	 *	data-facebook-caption="The sub-heading beneath the name"
	 *	data-facebook-description="Descriptive text"
	 *
	 * Example:
	 *	<a href="#" class="j-share-facebook" data-facebook-name="227!" data-facebook-link="http://www.twotwentyseven.com/" data-facebook-picture="http://twotwentyseven.com/images/227_logo.png" data-facebook-caption="Choose 227" data-facebook-description="Descriptive text">Share on Twitter</a>
	 **/

	$(document).on('click', '.j-share-facebook'	, function(e) {
		e.preventDefault();
		var facebook_name = $(this).data('facebook-name') || '';
		var facebook_link = $(this).data('facebook-link') || '';
		var facebook_picture = $(this).data('facebook-picture') || '';
		var facebook_caption = $(this).data('facebook-caption') || '';
		var facebook_description = $(this).data('facebook-description') || '';
		var facebook_callback = $(this).data('facebook-callback') || '';

		FB.ui({
			method: 'feed',
			name: facebook_name,
			description: facebook_description,
			caption: facebook_caption,
			link: facebook_link,
			picture: facebook_picture,
			display: 'popup'
		},
		function(response) {
			if ('' != facebook_callback) {
				eval(facebook_callback + '(response)');
			}
		});
	});


	/*
	 * Google+ share link
	 * Available data parameters:
	 *	data-google-link="The URL to share"
	 *
	 * Example:
	 *	<a href="#" class="j-share-google" data-google-link="http://www,twotwentyseven.com/">Share on Google+</a>
	 **/
	$(document).on('click', '.j-share-google', function(e) {
		e.preventDefault();
		var google_link = encodeURIComponent( $(this).data('google-link') || '');
		if ('' == google_link) {
			return;
		}
		popUp=window.open('https://plus.google.com/share?url='+google_link, 'popupwindow', 'scrollbars=yes,width=800,height=400');
		popUp.focus();
	});


	/*
	 * Pinterest share link
	 * Available data parameters:
	 *	data-pinterest-link="The URL to share"
	 *	data-pinterst-picture="The image to pin"
	 *	data-pinterest-text="The accompanying text"
	 *
	 * Example:
	 *	<a href="#" class="j-share-pinterest" data-pinterest-link="http://www,twotwentyseven.com/" data-pinterest-picture="http://twotwentyseven.com/images/227_logo.png" data-pinterest-caption="Choose 227">Share on Pinterest</a>
	 **/
	$(document).on('click', '.j-share-pinterest', function(e) {
		e.preventDefault();
		var pinterest_link = encodeURIComponent( $(this).data('pinterest-link') || '');
		var pinterest_picture = encodeURIComponent( $(this).data('pinterest-picture') || '');
		var pinterest_text  = encodeURIComponent ( $(this).data('pin-text') || '');

		// Only pin if there is something to pin
		if ('' == pinterest_picture) {
			return;
		}

		var target = 'http://pinterest.com/pin/create/button/?url='+pinterest_link+'&media='+pinterest_picture+'&description='+pinterest_text;
		popUp=window.open(target, 'popupwindow', 'scrollbars=yes,width=800,height=400');
		popUp.focus();
	});

});